import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import * as copyLessonSelectors from 'common.components/copy-lesson-modal/selectors';
import { CREATION_TYPE } from 'common.components/copy-lesson-modal/typings';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { LESSON_CONTENT_MODE } from 'common.components/lesson-view.store/typings';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { SIDE_PANEL_MODE } from './side-panel-mode';
import { LessonViewSidePanelStore } from './typings';

interface StoreWithLessonViewSidePanelStore {
    lessonViewSidePanel: LessonViewSidePanelStore;
}

const storeStateSelector = (storeState: StoreWithLessonViewSidePanelStore): LessonViewSidePanelStore =>
    storeState.lessonViewSidePanel;

export const getSidePanelMode = createSelector(
    [
        lessonSelectors.getLesson,
        lessonSelectors.getLessonAssignmentDate,
        lessonSelectors.getLessonAssignmentLoadingStatus,
        lessonViewSelectors.getShouldShowAssignmentSettings,
        copyLessonSelectors.getCopyStatus,
        lessonViewSelectors.getSelectedStudentId,
        lessonSelectors.getLessonLoadingStatus,
        lessonViewSelectors.getIsAfterCopying,
        copyLessonSelectors.getLessonCopyCreationType,
    ],
    // eslint-disable-next-line complexity
    (
        lesson,
        dateAssignment,
        lessonAssignmentLoadingStatus,
        shouldShowAssignmentSettings,
        copyStatus,
        selectedStudentId,
        lessonLoadingStatus,
        isAfterCopying,
        creationType
        // eslint-disable-next-line max-params
    ): SIDE_PANEL_MODE => {
        if (copyStatus === LOADING_STATUSES.LOADING) {
            if (creationType === CREATION_TYPE.COPY_AS_RNO) {
                return SIDE_PANEL_MODE.COPY_AS_RNO;
            }
            return SIDE_PANEL_MODE.COPY;
        }

        if (!lesson?.id) {
            return SIDE_PANEL_MODE.LOADING;
        }

        if (selectedStudentId && lessonLoadingStatus === LOADING_STATUSES.LOADING) {
            return SIDE_PANEL_MODE.LOADING;
        }

        if (dateAssignment && shouldShowAssignmentSettings) {
            return SIDE_PANEL_MODE.REASSIGNMENT;
        }

        if (dateAssignment) {
            return SIDE_PANEL_MODE.LESSON_STATS;
        }

        if (isAfterCopying) {
            return SIDE_PANEL_MODE.AFTER_COPYING;
        }

        return SIDE_PANEL_MODE.ASSIGNMENT;
    }
);

export const getIsExpanded = createSelector(
    [storeStateSelector],
    (state: LessonViewSidePanelStore): boolean => state.isExpanded
);

export const getShouldCollapseFooter = createSelector(
    [lessonViewSelectors.getLessonContentMode],
    (lessonContentMode: LESSON_CONTENT_MODE) =>
        lessonContentMode === LESSON_CONTENT_MODE.PROBLEM_VIEW ||
        lessonContentMode === LESSON_CONTENT_MODE.STUDENT_RESULTS
);

export const getShouldShowCopyLinkInput = createSelector(
    [lessonSelectors.getLessonStatus],
    (status: LESSON_STATUS): boolean => status === LESSON_STATUS.ASSIGNED || status === LESSON_STATUS.ASSIGNED_IN_FUTURE
);

export const getShouldShowSubscriptionWarning = createSelector(
    [lessonSelectors.getLessonActiveSubscriptionSlug, lessonSelectors.getCLessonId],
    (subscriptionSlug, clessonId) => Boolean(subscriptionSlug) && clessonId === null
);
